import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header");
  return _openBlock(), _createBlock(_component_Header);
}